import React from 'react';

interface PriceEntry { date: string; price: number; }
interface PriceChartProps { history: PriceEntry[]; }

const W = 320, H = 120;
const PAD = { top: 10, right: 10, bottom: 20, left: 50 };
const CW = W - PAD.left - PAD.right;
const CH = H - PAD.top - PAD.bottom;

export default function PriceChart({ history }: PriceChartProps) {
  if (history.length < 2) {
    return <p className="chart-empty">이력 2건 이상 시 그래프 표시</p>;
  }

  const d = history.slice(-30);
  const prices = d.map((e) => e.price);
  const mn = Math.min(...prices), mx = Math.max(...prices);
  const rng = mx - mn || 1;
  const yMin = mn - rng * 0.05, yMax = mx + rng * 0.05, yRng = yMax - yMin;

  const toX = (i: number) => PAD.left + (i / (d.length - 1)) * CW;
  const toY = (p: number) => PAD.top + CH - ((p - yMin) / yRng) * CH;

  const pts = d.map((e, i) => `${toX(i)},${toY(e.price)}`).join(' ');
  const area = `${toX(0)},${toY(yMin)} ${pts} ${toX(d.length - 1)},${toY(yMin)}`;

  const yTicks = [yMin, yMin + yRng / 2, yMax].map((v) => ({
    y: toY(v), label: Math.round(v).toLocaleString(),
  }));

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="price-chart">
      <polygon points={area} fill="rgba(3,199,90,0.1)" />
      <polyline points={pts} fill="none" stroke="#03c75a" strokeWidth="2" />
      {d.map((e, i) => (
        <circle key={i} cx={toX(i)} cy={toY(e.price)} r="3" fill="#03c75a">
          <title>{e.date}: {e.price.toLocaleString()}원</title>
        </circle>
      ))}
      {yTicks.map((t, i) => (
        <g key={i}>
          <line x1={PAD.left} y1={t.y} x2={W - PAD.right} y2={t.y} stroke="#eee" strokeWidth="1" />
          <text x={PAD.left - 4} y={t.y + 3} textAnchor="end" fontSize="9" fill="#999">{t.label}</text>
        </g>
      ))}
      <text x={PAD.left} y={H - 2} fontSize="9" fill="#999">{d[0].date.slice(5)}</text>
      <text x={W - PAD.right} y={H - 2} textAnchor="end" fontSize="9" fill="#999">{d[d.length - 1].date.slice(5)}</text>
    </svg>
  );
}
